import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";
import {NgForm} from "@angular/forms";
import {Product} from "../../../../objects/products/product";
import {ProductService} from "../../../../services/productService";
import {BlurUtil} from "../../../../common/utils/blurUtil";
import { ToastsManager } from "ng2-toastr";
/**
 * Created by alex.y on 9/11/2017.
 */

@Component({
    selector: 'product-modal',
    templateUrl: 'productModal.component.html',
    moduleId: module.id.toString()
})
export class ProductModalComponent{
    @ViewChild('productModal')
    public productModal: ModalDirective;

    @ViewChild("productForm")
    public productForm: NgForm;

    public originalProduct: Product = new Product();
    public currentProduct: Product = new Product();


    public string = String;
    public number = Number;

    public processing: boolean = false;

    @Input()
    private idToBlur: string;

    @Output()
    public productSaved: EventEmitter<Product> = new EventEmitter();

    constructor(public productService: ProductService, public toastr: ToastsManager) {

    }

    public show(product: Product): void {
        this.originalProduct = product;
        this.currentProduct = JSON.parse(JSON.stringify(product));
        this.productModal.show();

        BlurUtil.blurMenu(this.idToBlur);
    }

    public onModalHidden(): void {
        this.productForm.reset();
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public save(isValid: boolean): void {
        if (!isValid)
            return;

        this.processing = true;

        this.productService.update(this.currentProduct).then(response => {
            this.processing = false;

            if (this.currentProduct.ChangeOrders)
                this.toastr.success("Orders were updated");

            this.productSaved.emit(response.Data);
            this.productModal.hide();

        }).catch(() => {
            this.toastr.error("Does not change any order");
        });
    }

    public cancel(): void {
        this.productModal.hide();
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/productManagement/modal/productModal.component.ts